import { fork, takeEvery, put, call } from 'redux-saga/effects';

import watchReportConfigurationSaga from '../reportConfiguration/services/reportConfigurationSaga';
import * as types from './reportActionType';
import * as actions from './reportActions';
import * as services from './reportServices';

function* fetchPowerBIReportSaga(action) {
    const reportId = action.payload;
    console.log('fetchPowerBIReportSaga')
    try {
        const response = yield call(services.getPowerBIToken);
        const embedPayload = {
            token: response?.access_token,
            reportId
        }
        const embedResponse = yield call(services.getEmbedResponse, embedPayload);
        const tokenResponse = yield call(services.getTokenResponse, embedPayload);

        // Embed Power BI Report
        const embedConfig = {
            type: "report",
            id: reportId,
            embedUrl: embedResponse?.embedUrl,
            accessToken: tokenResponse?.token,
            tokenType: 1, // 1 for Embed Token
            // layoutType: 0,
            settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: false
            }
        };

        yield put(actions.fetchPowerBIReportSuccess(embedConfig));
    } catch (error) {
        console.error('PowerBI Report API Error:', error);
        yield put(actions.fetchPowerBIReportFailure('Failed to fetch PowerBI report'));
    }
}

export default function* reportSaga() {
    yield fork(watchReportConfigurationSaga);
    yield takeEvery(types.FETCH_POWER_BI_REPORT_REQUEST, fetchPowerBIReportSaga);
}